export const MULTI_ACCOUNT_CONFIG_KEY = "multiAccountConfig";
